export default {
  loading: true,
  listEntities: [],
  fieldEntities: [
    { key: 'valor', label: 'Código' },
    { key: 'descripcion', label: 'Nombre' },
    { key: 'actions', label: '' },
  ],
  pagination: {
    items: 0,
    pages: 0
  },
};
